export function formatCurrency(value: number): string {
  if (value >= 1000000) {
    return `$${(value / 1000000).toFixed(1)}M`
  }
  if (value >= 1000) {
    return `$${(value / 1000).toFixed(1)}k`
  }
  return `$${value.toLocaleString()}`
}

export function formatPercentage(value: number, options: {decimals?: number} = {}): string {
  const decimals = options.decimals ?? 1
  return `${(value * 100).toFixed(decimals)}%`
}

export function formatRate(value: number): string {
  return `${(value * 100).toFixed(1)}%`
}

export function formatInteger(value: number): string {
  return value.toLocaleString()
}

export function formatMonthlyGrowth(value: number): string {
  const prefix = value >= 0 ? '+' : ''
  return `${prefix}${(value * 100).toFixed(0)}% MoM`
}

export function formatTimestamp(date = new Date()): string {
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}
